<template>
  <div>
    <v-slider
      :rules="isItRequired"
      :label="generateLabel"
      :min="field.linked_attributes.min"
      :max="field.linked_attributes.max"
      :step="field.linked_attributes.step"
      :value="value || field.default"
      :hint="field.hint"
      :disabled="isDisabled"
      thumb-label
      dense
      @change="handleSliderChange"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "HTML5Slider",
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Number, Object],
      default: "",
    },
  },
  data: () => ({
    unsubscribe: null,
  }),
  computed: {
    ...mapState({
      currentFlow: (state) => state.company.currentFlow,
    }),
    isItRequired() {
      return this.field.element_required || this.field.required
        ? [this.validation.required]
        : undefined;
    },
    generateLabel() {
      return this.field.element_required || this.field.required
        ? `${this.field.published_name}*`
        : this.field.published_name;
    },
    isDisabled() {
      if (this.field.protected) {
        return true;
      }
      return false;
    },
  },
  created() {
    if (this.field.default) {
      this.handleSliderChange(this.field.default);
    }
    if (this.field.conditional_visibility) {
      this.handleConditionalVisibility();
    }
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  methods: {
    handleConditionalVisibility() {
      if (!this.field.conditional_visibility_values) return;
      const controllerField = this.currentFlow.config.payload_config.root_elements.find(
        (field) =>
          field.published_name === this.field.conditional_visibility_input
      );
      this.subscribeToMasterFieldChanges(controllerField);
    },
    subscribeToMasterFieldChanges(controlField) {
      this.unsubscribe = this.$store.subscribe((mutation) => {
        if (mutation.type === "company/setFlowData") {
          const controlFieldKey = controlField.key;
          if (
            !Object.prototype.hasOwnProperty.call(
              mutation.payload,
              controlFieldKey
            )
          )
            return;
          const value = mutation.payload[controlFieldKey];
          if (this.field.conditional_visibility_values.includes(value)) {
            this.$emit("manage-field-visibility", {
              visibility: false,
              field: this.field.key,
            });
            return;
          }
          this.$emit("manage-field-visibility", {
            visibility: true,
            field: this.field.key,
          });
        }
      });
    },
    handleSliderChange(value) {
      this.$emit("text-change", { [this.field.key]: value });
    },
  },
};
</script>
